import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FileSystemImplementation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="File System Implementation and Recovery"
    videos={[
      "https://www.youtube.com/embed/t8Rs9AbqHUc?si=3HNb9Inzx8fsYZoQ",
      "https://www.youtube.com/embed/gSks2GpUx3Q?si=r7G2lY-dnTF7a33l",
      "https://www.youtube.com/embed/Lhr48wCtvKU?si=SRg942-GabSCTfmT",
      "https://www.youtube.com/embed/-KKj3WF1MFM?si=0ek32bV3hhgIZ51S",
      "https://www.youtube.com/embed/QT1mBAJBuoA?si=-kKBv0UrF0CTR2lw",
      "https://www.youtube.com/embed/gK6L3v1b8AM?si=fY2gu_PajYq9IECL",
      "https://www.youtube.com/embed/4ZXt8FmSK3M?si=_oc6yoD0RsYG8o_L",
      "https://www.youtube.com/embed/Xhi3hqbiXNM?si=5k0RZOUM2dX_yVzP"
    ]}
    takeaways={[]}
    questions={[
      "1) What is a virtual file system? Why is this concept especially useful for those who manage large-scale computing systems?",
      "2) Explain the file allocation methods and rank them based on random access support and less memory wastage.",
      "3) List out 6 differences between Local File System (LFS) and Distributed File System (DFS).",
      "4) Describe the different file allocation methods used in operating systems. Discuss the characteristics, advantages, and limitations of each method.",
      "5) Investigate the various types of directory structures used in file systems, Analyze the advantages and disadvantages of each type in terms of efficiency, usability, and scalability. How do these directory structures influence file retrieval and management in different operating systems? Propose a scenario where a specific type of directory would be most effective, and justify your choice based on system requirements.",
      "6) Examine the various file allocation methods. Analyze the trade-offs of each method in terms of disk space efficiency, access speed, and fragmentation. In what situations might one allocation method be preferred over the others? Discuss how your findings could impact the design of file systems in modern computing environments."
    ]}
    exampleVideos={[]}
  />
);
}

export default FileSystemImplementation;
